import { Outlet } from 'react-router-dom';
import { PatientPortalBrandingProvider } from './PatientPortalBrandingProvider';

/** Wraps authenticated patient routes with tenant branding (hospital name). */
export default function PatientPortalShell() {
  return (
    <PatientPortalBrandingProvider>
      <Outlet />
    </PatientPortalBrandingProvider>
  );
}
